const FILTER_STATE_KEY_PREFIX = "filter_state_";

export interface StoredFilterState {
  dateRange: [string | null, string | null];
  statusFilter: number | boolean | null;
  selectedRange?: string;
}

type PageType =
  | "company"
  | "contact"
  | "deal"
  | "lead"
  | "pipeline"
  | "subscription"
  | "proposal"
  | "contract";

/**
 * Get stored filter state for a specific module
 */
export const getStoredFilterState = (
  page: PageType
): StoredFilterState | null => {
  try {
    const key = `${FILTER_STATE_KEY_PREFIX}${page}`;
    const stored = localStorage.getItem(key);
    if (!stored) return null;

    const filterState: StoredFilterState = JSON.parse(stored);
    return filterState;
  } catch (error) {
    console.warn("Error reading filter state:", error);
    return null;
  }
};

/**
 * Save filter state for a specific module
 */
export const setFilterState = (
  page: PageType,
  filterState: StoredFilterState
): void => {
  try {
    const key = `${FILTER_STATE_KEY_PREFIX}${page}`;
    localStorage.setItem(key, JSON.stringify(filterState));
  } catch (error) {
    console.warn("Error saving filter state:", error);
  }
};

/**
 * Clear filter state for a specific module
 */
export const clearFilterState = (page: PageType): void => {
  try {
    const key = `${FILTER_STATE_KEY_PREFIX}${page}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.warn("Error clearing filter state:", error);
  }
};

/**
 * Clear all filter states
 */
export const clearAllFilterStates = (): void => {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(FILTER_STATE_KEY_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    console.warn("Error clearing all filter states:", error);
  }
};
